import Swal from "sweetalert2";

/** Defaults for all admin confirmations — stacks above in-app modals (z-index), Naseebi red accents. */
const swalDefaults = {
  showCancelButton: true,
  reverseButtons: true,
  focusCancel: true,
  allowOutsideClick: true,
  zIndex: 20000,
  width: "28rem",
  padding: "1.25rem",
  buttonsStyling: true,
  customClass: {
    popup: "naseebi-swal-popup",
    title: "naseebi-swal-title",
    htmlContainer: "naseebi-swal-html",
    confirmButton: "naseebi-swal-btn-confirm",
    cancelButton: "naseebi-swal-btn-cancel",
  },
};

/**
 * @param {object} opts
 * @param {string} [opts.title]
 * @param {string} [opts.text] - plain text (ignored if html set)
 * @param {string} [opts.html]
 * @param {'warning'|'error'|'question'|'info'|'success'} [opts.icon]
 * @param {string} [opts.confirmButtonText]
 * @param {string} [opts.cancelButtonText]
 * @param {string} [opts.confirmButtonColor] - hex
 * @param {string} [opts.cancelButtonColor]
 * @returns {Promise<boolean>} true if user confirmed
 */
export async function confirmDialog(opts = {}) {
  const {
    title = "Please confirm",
    text,
    html,
    icon = "warning",
    confirmButtonText = "Confirm",
    cancelButtonText = "Cancel",
    confirmButtonColor = "#dc2626",
    cancelButtonColor = "#6b7280",
    customClass: customClassOverride,
    ...rest
  } = opts;

  const mergedClass = {
    ...swalDefaults.customClass,
    ...(customClassOverride && typeof customClassOverride === "object" ? customClassOverride : {}),
  };

  const result = await Swal.fire({
    ...swalDefaults,
    ...rest,
    customClass: mergedClass,
    title,
    ...(html ? { html } : { text: text ?? "" }),
    icon,
    confirmButtonText,
    cancelButtonText,
    confirmButtonColor,
    cancelButtonColor,
  });

  return Boolean(result.isConfirmed);
}

/** Destructive actions (delete, permanent remove). */
export function confirmDanger(text, title = "Are you sure?") {
  return confirmDialog({
    title,
    text,
    icon: "warning",
    confirmButtonText: "Delete",
    confirmButtonColor: "#dc2626",
  });
}

/** Positive / recovery actions (restore, unban). */
export function confirmRestore(text, title = "Confirm action") {
  return confirmDialog({
    title,
    text,
    icon: "question",
    confirmButtonText: "Yes, proceed",
    confirmButtonColor: "#15803d",
  });
}

/** Broad confirmations (send to all, force ban, etc.). */
export function confirmWarning(text, title = "Please confirm") {
  return confirmDialog({
    title,
    text,
    icon: "warning",
    confirmButtonText: "Confirm",
    confirmButtonColor: "#b91c1c",
  });
}
